export const RegexConst = {
    number: '[0-9]*',
    email: '^\\s*((?:\\w+(.\\w+)?@[a-zA-Z_]+?(\\.[a-zA-Z]{2,3})(\\.[a-zA-Z]{2,2})?\\b\\s*))+$',
}